module.exports = file => () => import('@/views/bizViews/' + file + '.vue')


// WEBPACK FOOTER //
// ./src/router/_import_production.js